<template>
    <div :class="{'table-container': mobile}" class="container">
        <table class="forecast-table" align="center">
            <tr>
                <th class="text-left">{{ $t('other_party') }}</th>
                <th class="text-center">{{ $t('other_forecast') }}</th>
                <th class="text-center">{{ $t('other_fourteen_day_trend') }}</th>
            </tr>
            <tr v-for="party in data" v-bind:key="party.party_id">
                <td>
                    <span :class="['party-name', 'party-' + party.party_id]">
                        {{ party.party}}
                    </span>
                </td>
                <td class="text-left">
                    <ForecastCell :estimate="party.forecast" :lower="party.forecast_lower" :upper="party.forecast_upper"/>
                </td>
                <td class="text-center trend">
                    <div :class="['trend-arrow', 'trend' + '-' + party.trend.direction]">
                        
                        <font-awesome-icon :icon="['fas','arrow-circle-right']" />
                        
                    </div>
                    <div class="trend-value">
                    ({{ party.trend.value | plusminus }})
                    </div>
                </td>
            </tr>
        </table>
    </div>
</template>

<script>
import ForecastCell from '@/components/ForecastCell';
import { mapState } from 'vuex';

export default {
    name: 'ForecastTable',
    props: ['data'],
    components: {
        ForecastCell
    },
    computed: {
        ...mapState(["windowWidth"]),
        mobile() {
            return this.windowWidth < 800;
        },
    },
    methods: {
        lighten (color, amount) {
            return color.replace(')', ', ' + amount + ')').replace('rgb', 'rgba')
        }
    }
}
</script>

<style scoped>
table th {
    font-weight: 800;
    font-style: italic;
}

.trend {
    padding-top: 15px;
}

.trend-arrow {
    font-weight: bold;
    color: var(--blue-dark);

    position: relative;
}

.trend-down {
    transform: rotate(45deg);
}

.trend-up {
    transform: rotate(-45deg);
}

.trend-value {
    padding-top: 4px;
    font-size: 0.75rem;
    color: black;
}

.party-name {
    white-space: nowrap;
}

.forecast-table tr:first-child th {
    white-space: nowrap;
}

</style>